import gql from 'graphql-tag';
import { VariantFragments } from './variant';
import { VideoFragments } from './video';

export namespace PurchasableFragments {
  export const Purchasable = gql`
    fragment Purchasable on IPurchasable {
      id
      title
      description
      price
      imageUrls
      ... on Product {
        isCitizenRestricted
        sortOrder
        requiredScore
        variants {
          ...Variant
        }
      }
      ... on MeetAndGreetProduct {
        sortOrder
        loyalExclusive
        randomExclusive
        variants {
          ...Variant
        }
      }
      ... on Passport {
        video {
          ...Video
        }
        variant {
          ...Variant
        }
      }
    }
    ${VariantFragments.Variant}
    ${VideoFragments.Video}
  `;
}
